<script lang="js" setup>
import { inApp } from '@/utils/inApp'
import { useUserStore } from '~/store/user'
import xMod from '@/components/common/xMod.vue'
import Rules from '../Rules.vue'
import Header from './components/Header.vue'
import Overview from './components/Overview.vue'
import Invite from './components/Invite.vue'
import Footer from './components/Footer.vue'
import InviteList from './components/InviteList.vue'
import RebateList from './components/RebateList.vue'

defineProps({
  overview: {
    type: Object,
    default: () => ({}),
  },
})
const { t } = useI18n()
const user = useUserStore()
const localePath = useLocalePath()

const shareUrl = computed(() => {
  const path = localePath(`/sign-up?invitCode=${user.info.sharecode}`)
  if (import.meta.client) {
    return location.origin + path
  }
})

const tabs = computed(() => [
  {
    title: t('邀请记录'),
    key: 'invite',
    component: InviteList,
  },
  {
    title: t('返佣记录'),
    key: 'rebate',
    component: RebateList,
  },
])
</script>

<template>
  <div>
    <Header />
    <div class=" relative">
      <Overview class="py-6 px-4" :overview="overview" />
      <div class="px-4  pt-2">
        <Invite />
      </div>
      <div class="pt-4">
        <xMod :tabs="tabs" class="h-full" header-class="!h-[34px] !text-base font-medium px-4 whitespace-nowrap overflow-auto w-[calc(100vw)] [&::-webkit-scrollbar]:hidden" component-class="!px-0" />
      </div>

      <Rules class="p-4" :class="{ 'mb-[100px]': inApp }" />
      <Footer class="p-4" :share-url="shareUrl" />
    </div>
  </div>
</template>
